export default "__VITE_ASSET__ZqapwzRj__"